module.exports = __webpack_public_path__ + "static/media/michael.3d749c6f.jpg";